const apiUrl = 'https://ckwin44.com';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

async function ensureCsrfCookie() {
  if (!getCookie('csrftoken')) {
    await fetch(`${apiUrl}/api/csrf/`, { credentials: 'include' });
  }
}

export const authProvider = {
  login: async ({ username, password }) => {
    await ensureCsrfCookie();
    const response = await fetch(`${apiUrl}/api/auth/login/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': getCookie('csrftoken'),
      },
      credentials: 'include',
      body: JSON.stringify({ username, password }),
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.detail || 'Login failed');
    }

    const user = await response.json();
    localStorage.setItem('user', JSON.stringify(user));
  },

  logout: async () => {
    await fetch(`${apiUrl}/api/auth/logout/`, {
      method: 'POST',
      headers: { 'X-CSRFToken': getCookie('csrftoken') },
      credentials: 'include',
    });
    localStorage.removeItem('user');
  },

  checkAuth: () =>
    fetch(`${apiUrl}/api/auth/user/`, { credentials: 'include' }).then((res) =>
      res.ok ? Promise.resolve() : Promise.reject()
    ),

  checkError: (error) => {
    const status = error?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem('user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  getIdentity: () => {
    try {
      return Promise.resolve(JSON.parse(localStorage.getItem('user')));
    } catch {
      return Promise.reject();
    }
  },

  getPermissions: () => Promise.resolve(),
};